
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import SingleSelect from "@/components/SingleSelect.vue";
import Diagram from "@/components/Diagram.vue";

export default Vue.extend({
  name: "Ganglinie",
  components: {
    Loader,
    SingleSelect,
    Diagram
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      messleitungenView: {
        name: "gus_messwerte_messleitungen",
        condition: "MESSST_NR=number:" + this.id
      },
      leitung_nr: null as number | null,
      stoff_nr: 0,
      diagramData: {} as any
    };
  },
  computed: {
    stoffeView: function() {
      // Zeitraum ermitteln
      const date = new Date();
      date.setDate(date.getDate() - 30); // Subtract 30 days

      return {
        name: "gus_stoff_stoffeganglinie",
        condition: [
          "messst_nr=number:" + this.id,
          (this as any).leitung_nr
            ? "leitung_nr=number:" + (this as any).leitung_nr
            : ""
        ]
      };
    },
    messwerteView: function() {
      // Zeitraum ermitteln
      const date = new Date();
      date.setDate(date.getDate() - 30); // Subtract 30 days
      return {
        name: "gus_messwerte_messwerteganglinie",
        condition: [
          "MESSST_NR=number:" + this.id,
          (this as any).leitung_nr
            ? "leitung_nr=number:" + (this as any).leitung_nr
            : "",
          "stoff_nr=number:" + (this as any).stoff_nr
        ]
      };
    },

    stoffDetailView: function() {
      return {
        name: "gus_stoff_stoffdetails",
        condition: "stoff_nr=number:" + (this as any).stoff_nr
      };
    }
  },
  methods: {
    toNumber(v: any) {
      if (isNaN(v)) return 0;
      else {
        if (Number.isInteger(v)) {
          return v.toFixed(0);
        } else {
          const formatted = v.toFixed(2).replace(".", ",");
          return formatted.endsWith("0") ? formatted.slice(0, -1) : formatted;
        }
      }
    },
    loadedStoffe(stoffliste: any[]) {
      if (!this.stoff_nr && stoffliste != null && stoffliste.length > 0)
        this.stoff_nr = stoffliste[0].stoff_nr;
    },
    loadedMesswerte(data: any[]) {
      const messwerte = data[0];
      const stoffdetails = data[1][0];

      const title =
        (stoffdetails.stoff_bezeichnung ? stoffdetails.stoff_bezeichnung : "") +
        " (" +
        (stoffdetails.stoff_einheit ? stoffdetails.stoff_einheit : "") +
        ")";
      const list = messwerte
        // map data to format
        .map(messwert => {
          const element = {
            xValue: Date.parse(messwert.datum),
            yValue: messwert.messwert
          };

          return Object.assign(messwert, element);
        });

      // create diagram object
      this.diagramData = {
        // default data
        legendText: "Ganglinie",
        xUnit: "",
        yUnit: title,
        // value list
        list
      };
    }
  }
});
